import {Component, EventEmitter, Inject, Injector, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ProviderService} from "../../../_services/provider.service";
import {CertService} from "../../dashboard/services/cert.service";
import {ParameterService} from "../../../_services/parameter.service";
import {MatSelectChange} from "@angular/material/select";
import {BaseComponentDirective} from "../../../_shared/base/base.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {UserService} from "../../dashboard/services/user.service";
import {isMoment} from "moment";

@Component({
    selector: 'modal-add-user-certification',
    templateUrl: './add-user-certification.modal.html',
})
export class AddUserCertificationModal extends BaseComponentDirective implements OnInit {
    public result = new EventEmitter();
    public form: FormGroup;
    public providers: any[] = [];
    public titles: any[] = [];
    public attendanceTypes: any = {};
    constructor(
        injector: Injector,
        public dialogRef: MatDialogRef<AddUserCertificationModal>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private formBuilder: FormBuilder,
        private providerService: ProviderService,
        private parameterService: ParameterService,
        private userService: UserService,
        private certService: CertService,
        private snackbar: MatSnackBar
    ) {
        super(injector);
        this.form = this.formBuilder.group({
            provider: [null, [Validators.required]],
            title: [null, [Validators.required]],
            attendanceType: [null, [Validators.required]],
            certification: [null, [Validators.required]],
            dateEarned: [null, [Validators.required]],
            earnedCertificationId: [null, []]
        });
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        //TODO: replace it with new provider
        this.providers = await this.providerService.getAllProvider();
        this.attendanceTypes = await this.parameterService.getParameterByName("ATTENDANCE_TYPE");

        if(this.data && this.data.mode == 'edit') {
            this.titles = await this.certService.getCertificationByProvider(this.data.provider);
            this.form.controls.provider.disable({onlySelf: true});
            this.form.controls.title.disable({onlySelf: true});

            this.setDefaultEdit();
        }
    }

    setDefaultEdit() {

        this.form.controls.provider.setValue(this.data.provider);
        this.form.controls.title.setValue(this.data.id);
        this.form.controls.attendanceType.setValue(this.data.attendanceType);
        this.form.controls.certification.setValue(this.data.providerAssignedId);
        this.form.controls.dateEarned.setValue(this.data.acquiredDate);
        this.form.controls.earnedCertificationId.setValue(this.data.earnedCertificationId);
    }

    async onProviderChange($event: MatSelectChange): Promise<void> {
        this.titles = await this.certService.getCertificationByProvider($event.value);
    }

    closeDialog() {
        this.dialogRef.close();
    }

    resetForm() {
        if(this.data && this.data.mode == 'edit') {
            this.setDefaultEdit();
        } else {
            this.form.reset();
            this.form.markAsPristine();
            this.form.markAsUntouched();
        }
    }

    save() {
        const validation = this.check(this.form);
        if(validation) {
            this.showAlert('Warning', 'Please fill all required input', '');
            return;
        }

        if(this.data.mode == 'edit') {

            this.userService.updateCertification({
                certificationId: this.form.controls.title.value,
                provider: this.form.controls.provider.value,
                attendanceType: this.form.controls.attendanceType.value,
                acquiredDate: (isMoment(this.form.controls.dateEarned.value)) ? this.date.momentToDbDate(this.form.controls.dateEarned.value) : this.form.controls.dateEarned.value,
                providerAssignedId: this.form.controls.certification.value,
                earnedCertificationId: this.form.controls.earnedCertificationId.value
            }).then(_ => {
                this.snackbar.open('Certification has been updated successfully!', null, {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'right'
                });
                this.result.emit(true);
                this.closeDialog();
            })

        } else {
            this.userService.addCertification({
                certificationId: this.form.controls.title.value,
                provider: this.form.controls.provider.value,
                attendanceType: this.form.controls.attendanceType.value,
                acquiredDate: this.date.momentToDbDate(this.form.controls.dateEarned.value),
                providerAssignedId: this.form.controls.certification.value
            }).then(_ => {
                this.snackbar.open('Certification has been added successfully!', null, {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'right'
                });
                this.result.emit(true);
                this.closeDialog();
            })
        }

    }

    saveAdmin() {
        const validation = this.check(this.form);
        if(validation) {
            this.showAlert('Warning', 'Please fill all required input', '');
            return;
        }

        if(this.data.mode == 'edit') {

            this.certService.updateCertification({
                certificationId: this.form.controls.title.value,
                provider: this.form.controls.provider.value,
                attendanceType: this.form.controls.attendanceType.value,
                acquiredDate: (isMoment(this.form.controls.dateEarned.value)) ? this.date.momentToDbDate(this.form.controls.dateEarned.value) : this.form.controls.dateEarned.value,
                providerAssignedId: this.form.controls.certification.value,
                userId: this.data.userId,
                earnedCertificationId: this.data.earnedCertificationId
            }).then(_ => {
                this.snackbar.open('Certification has been updated successfully!', null, {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'right'
                });
                this.result.emit(true);
                this.closeDialog();
            })

        } else {
            this.certService.addCertification({
                certificationId: this.form.controls.title.value,
                provider: this.form.controls.provider.value,
                attendanceType: this.form.controls.attendanceType.value,
                acquiredDate: this.date.momentToDbDate(this.form.controls.dateEarned.value),
                providerAssignedId: this.form.controls.certification.value,
                userId: this.data.userId
            }).then(_ => {
                this.snackbar.open('Certification has been added successfully!', null, {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'right'
                });
                this.result.emit(true);
                this.closeDialog();
            })
        }

    }
}
